import { render, staticRenderFns } from "./unsupportedBrowser.vue?vue&type=template&id=f440658e&scoped=true"
import script from "./unsupportedBrowser.vue?vue&type=script&lang=js"
export * from "./unsupportedBrowser.vue?vue&type=script&lang=js"
import style0 from "./unsupportedBrowser.vue?vue&type=style&index=0&id=f440658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f440658e",
  null
  
)

export default component.exports